import { useForBinding } from '@practium/features/forBinding';
import { usePermissions } from '@practium/features/permissions';
import { FoliarAdvicePage } from '@practium/features/recommendations';
import { LoadingState, useToast } from '@practium/ui';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getRecommendationsListPath } from '../routes';
import {
	useDeleteAdviceFoliar,
	useGetAdviceFoliarById,
	useGetAdviceFoliarReport,
} from '@practium/features/api';
import { useMemo } from 'react';

export const ViewFoliarAdvicePageClient = () => {
	const navigate = useNavigate();
	const toast = useToast();
	const [searchParams] = useSearchParams();
	const id = searchParams.get('id') || '';
	const { isForBinding } = useForBinding();
	const { abilities } = usePermissions();
	const subject = isForBinding ? 'farmers-recommendations' : 'recommendations';
	const { data: advice, isLoading } = useGetAdviceFoliarById(id);
	const { mutateAsync: deleteFoliarAdvice, isPending: isDeleting } = useDeleteAdviceFoliar();
	const { data: reportFile, isLoading: isLoadingReport } = useGetAdviceFoliarReport(id);

	const canEdit = abilities.can('update', subject);

	const canDelete = abilities.can('delete', subject);

	const reportUrl = useMemo(() => {
		if (!reportFile) return undefined;
		return URL.createObjectURL(reportFile);
	}, [reportFile]);

	if (isLoading || isDeleting || !advice || isLoadingReport) {
		return <LoadingState />;
	}

	const adviceFoliar = {
		...advice,
		reportUrl: reportUrl,
	};

	const handleDelete = async () => {
		try {
			await deleteFoliarAdvice(id);
		} catch {
			toast.error('Erro ao excluir recomendação.');
		}
		navigate(getRecommendationsListPath('foliar'));
	};

	return (
		<FoliarAdvicePage
			onBack={() => navigate(getRecommendationsListPath('foliar'))}
			initialMode="view"
			viewData={adviceFoliar}
			adviceId={id}
			canEdit={canEdit}
			onDelete={canDelete ? handleDelete : undefined}
		/>
	);
};
